import {TooltipContent} from "@bounce/shared/consumer/bounce-ui";
import {Text} from "@bounce/shared/ui";
import {Link} from "@mui/material";
import {useAmplitude} from "~/contexts";
import {Pages} from "~/bi-events/enum";
import React from "react";

interface IChatTooltipLabel {
  handleClick: () => void;
  onClose: () => void;
}

export const ChatTooltipLabel = ({handleClick, onClose}: IChatTooltipLabel) => {
  const {pageClickEvent} = useAmplitude();

  const handleCloseChat = () => {
    pageClickEvent({page: Pages.CHAT_BANNER, cta: "close"});
    onClose();
  };

  return (
    <TooltipContent onClose={handleCloseChat}>
      <Text fontWeight={"bold"} size={14}>
        Need some help?
      </Text>
      <Text size={14}>
        Reach out to one of our resolution experts.{" "}
        <Link onClick={handleClick} sx={{textDecoration: "none"}}>
          <Text size={14} fontWeight={"bold"} sx={{color: "secondary", display: "inline", cursor: "pointer"}}>
            Chat Now
          </Text>
        </Link>
      </Text>
    </TooltipContent>
  );
};
